import { HttpContextToken, HttpRequest } from '@angular/common/http';

export const SkipByLoadingInterceptor = new HttpContextToken(() => true);

export const isSkippedByLoading = <Body>(
  request: HttpRequest<Body>
): boolean => {
  return request.context.has(SkipByLoadingInterceptor);
};
